<template>
    <div class="card" @click="goTo(link)">
        <div class="imageContainer">
            <img :src="image" class="card-img" alt="..."/>
            <div class="overlay">
                <h3 class="card-title">{{ title }}</h3>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ImageCard',
    props: {
        title: {
            type: String,
            required: true,
            default: () => ""
        },
        link: {
            type: String,
            required: true,
            default: () => ""
        },
        image: {
            type: String,
            required: true,
            default: () => ""
        }
    },
    methods: {
        goTo: function(link) {
            this.$router.push(link);
        }
    }
}
</script>

<style lang="scss" scoped>
    $border-radius: 8px;
    $card-bg: #f7f7f7;
    $overlay-bg: rgba(255, 255, 255, 0.8);

    .card {
        border: none;
        border-radius: $border-radius;
        margin: 10px;
        overflow: hidden;
        cursor: pointer;
        background-color: $card-bg;
        box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
        transition: box-shadow 0.3s ease;
        &:hover {
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
        }
    }

    .imageContainer {
        position: relative;
        border-radius: $border-radius;
        overflow: hidden;
        aspect-ratio: 1/1;
    }

    .card-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.3s ease-in-out;
    }

    .overlay {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
        padding: 10px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background: $overlay-bg;
        opacity: 1;
        transition: opacity 0.3s ease;
    }

    .card-title {
        color: $text-color;
        text-align: center;
        transition: opacity 0.3s ease;
    }

    // Hover effects
    .card:hover .card-img {
        transform: scale(1.05);
    }

    .card:hover .overlay {
        opacity: 0;
    }
</style>
